<template>
  <section class="bill-wrapper">
    <div class="order_list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-checkbox-group v-model="chooseResult" @change="onChooseChange" ref="checkboxGroup">
          <van-cell-group v-for="(item, index) in orders" :key="index" @click.stop="onSingleChoose(item, index)"
            class="order_list__group">
            <!-- 停车场、复选框 -->
            <van-cell :title="item.parkName">
              <van-checkbox :disabled="sameArea==0?false:sameArea!=item.nsrsbh" icon-size="14px" :name="item"
                @click.stop="onSingleChoose(item, index)" ref="checkBoxes" slot="right-icon" />
            </van-cell>
            <!-- 基础信息 -->
            <van-cell :title="item.plateNmuber" :label="item.date">
              <div slot="default" class="order_list__group__price">
                ¥
                <div class="order_list__group__price__integer">
                  {{ item.priceArr[0] }}
                </div>
                .
                {{ item.priceArr[1] }}
              </div>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="order_handler">
      <van-submit-bar safe-area-inset-bottom :price="totalPrice" button-text="确认开票" button-type="info"
        @submit="onSubmit">
        <van-checkbox :disabled="this.chooseResult.length==0" v-model="checked">同类全选</van-checkbox>
        <span class="order_handler__tip" slot="tip">
          已选
          <span class="order_handler__tip__num">{{ chooseResult.length }}</span>
          条订单
        </span>
      </van-submit-bar>
    </div>
  </section>
</template>

<script>
import { List, CellGroup, Checkbox, CheckboxGroup, SubmitBar } from 'vant'
import { parseTime } from '@/utils'


export default {
  props: {
    orders: {
      type: Array,
      default () {
        return {}
      }
    }
  },
  components: {
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [SubmitBar.name]: SubmitBar
  },
  watch: {
    // 全选反选切换
    checked (val) {
      if (val) {
        for (let i = 0; i < this.orders.length; i++) {
          if (this.sameArea == this.orders[i].nsrsbh) {
            this.$refs.checkBoxes[i].toggle(true)
          }
        }
      } else {
        this.$refs.checkboxGroup.toggleAll()
        this.sameArea = 0
      }
    },
    // 监听是否有选择
    chooseResult (val) {
      if (val.length === 0) {
        this.sameArea = 0
      }
    }
  },
  data () {
    return {
      sameArea: 0,
      totalPrice: 0,
      chooseResult: [], //选择项
      loading: false, //加载中。。。
      finished: false, //结束所有状态
      checked: false
    }
  },
  methods: {
    onLoad () {
      setTimeout(() => {
        for (let i = 10; i < 20; i++) {
          let item = {
            orderNum: i * 10000,
            parkName: '众彩物流地下停车场',
            plateNmuber: '苏A5B618',
            date: parseTime(new Date(new Date().toLocaleDateString())),
            paidMoney: i,
            nsrsbh: i + 1
          }
          if (typeof item.paidMoney === 'number') {
            item.priceArr = item.paidMoney.toFixed(2).split('.')
          }
          this.orders.push(item)
        }
        this.loading = false
        if (this.orders.length >= 40) {
          this.finished = true
        }
      }, 1000)
    },
    // 单选
    onSingleChoose (item, index) {
      // When toggle method is called multiple times at the same time,
      // only the last call is valid.
      // This is a hack for usage inside Cell.
      //源码中该方法是异步的，所以后续打印不会立即展示结果
      if (this.sameArea == 0) {
        this.sameArea = item.nsrsbh
      }
      if (this.sameArea == item.nsrsbh) {
        this.$refs.checkBoxes[index].toggle()
      }
    },
    onChooseChange (val) {
      this.totalPrice = val.reduce(function (prev, cur) {
        return cur.paidMoney * 100 + prev
      }, 0)
    },
    //确认开票
    async onSubmit () {
      if (this.chooseResult.length === 0) {
        this.$toast.fail('请选择订单');
        return
      }
      let params = {
        openid: '88d19509e02c4ccea04ab68239bdacd3',
        appsecret: 'a716e819968c4618ba17e5656aba2c4b',
      }
      await this.$store.dispatch('invoice/GetToken', params)
      this.$router.push({ name: 'Invoice-Form' })
      this.$store.dispatch('invoice/SetPendingBill', this.chooseResult)
    }
  }
}
</script>


<style lang="scss" scoped>
.bill-wrapper {
  height: 100vh;
  background-color: #f5f5f5;

  .order_list {
    overflow-y: auto;
    padding: 0 8px 0;
    height: calc(100vh - 84px - 1px);

    &__group {
      margin: 5px 0 5px;

      &__price {
        color: #4b62ec;
        font-weight: 500;
        font-size: 12px;

        &__integer {
          display: inline-block;
          font-size: 20px;
          font-family: Avenir-Heavy, PingFang SC, Helvetica Neue, Arial,
            sans-serif;
        }
      }
    }
  }

  .order_handler {
    /deep/ .van-submit-bar__tip,
    &__tip {
      color: #444444;
      background-color: #ffffff;
      border-bottom: 1px solid #f5f5f5;

      &__num {
        color: #f56723;
      }
    }
  }
}
</style>